import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  Stack,
  Paper,
  IconButton,
  Tooltip,
  Collapse,
  Alert,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useState } from "react";

const AddNewCa = ({ newCaName, setNewCaName, handleCreate }) => {
  const [showHint, setShowHint] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newCaName.trim()) {
      handleCreate();
    }
  };

  return (
    <Paper
      component='form'
      onSubmit={handleSubmit}
      elevation={0}
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        overflow: "hidden",
      }}
    >
      {/* Header Section */}
      <Box
        sx={{
          p: 3,
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: "primary.lighter",
        }}
      >
        <Stack spacing={1}>
          <Stack direction='row' spacing={1} alignItems='center'>
            <AddCircleOutlineIcon color='primary' />
            <Typography variant='h6' fontWeight='bold' color='primary.main'>
              Create New CA Setting
            </Typography>
            <Tooltip title='Toggle naming guidelines'>
              <IconButton
                size='small'
                onClick={() => setShowHint(!showHint)}
                sx={{ ml: "auto" }}
              >
                <HelpOutlineIcon fontSize='small' color='action' />
              </IconButton>
            </Tooltip>
          </Stack>
          <Collapse in={showHint}>
            <Alert
              severity='info'
              sx={{
                mt: 1,
                borderRadius: 2,
                "& .MuiAlert-message": { fontSize: "0.875rem" },
              }}
            >
              Naming Guidelines:
              <ul style={{ margin: "4px 0", paddingLeft: "20px" }}>
                <li>Include the section number (e.g., S19A)</li>
                <li>Specify subsections if applicable (e.g., 2 to 10A)</li>
                <li>Add year information if relevant</li>
                <li>Example: "S19A(2 to 10) 2 year"</li>
              </ul>
            </Alert>
          </Collapse>
        </Stack>
      </Box>

      {/* Form Section */}
      <Box sx={{ p: 3 }}>
        <Grid container spacing={2} alignItems='flex-start'>
          <Grid item xs={12} md={9}>
            <TextField
              label='CA Name'
              placeholder='e.g., S19A(2 to 10) 2 year'
              value={newCaName}
              onChange={(e) => setNewCaName(e.target.value)}
              fullWidth
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  backgroundColor: "background.default",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "action.hover",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "primary.main",
                    },
                  },
                  "&.Mui-focused": {
                    backgroundColor: "background.paper",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "primary.main",
                      borderWidth: 2,
                    },
                  },
                },
                "& .MuiInputLabel-root": {
                  "&.Mui-focused": {
                    color: "primary.main",
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              type='submit'
              variant='contained'
              startIcon={<AddCircleOutlineIcon />}
              fullWidth
              disabled={!newCaName.trim()}
              sx={{
                height: "56px",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.9375rem",
                borderRadius: 2,
                backgroundColor: "primary.main",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor: "primary.dark",
                  transform: "translateY(-1px)",
                  boxShadow: "0 4px 12px rgba(96, 63, 151, 0.2)",
                },
                "&:active": {
                  transform: "translateY(0)",
                },
                "&.Mui-disabled": {
                  backgroundColor: "action.disabledBackground",
                  color: "action.disabled",
                },
              }}
            >
              Add CA
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default AddNewCa;
